import { render } from "./UploadFileModal.vue?vue&type=template&id=af5af142"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"

import "./UploadFileModal.vue?vue&type=style&index=0&id=af5af142&lang=css"
script.render = render

export default script